<template>
  <div class="nHome-detail" v-if="info && info.id">
    <div class="radiusArrow" @click="back">
      <div class="rt_pos"></div>
    </div>

    <div class="hero" @click="openImg(0)">
      <img :src="images[0]" :alt="info.xuanfei_name" />
    </div>

    <div class="content">
      <div class="notice">
        <van-notice-bar
          left-icon="volume-o"
          scrollable
          :text="notice || defaultNotice"
          background="transparent"
          color="#ddb285"
        />
        <div class="icon2">{{ $t("zise.zhuyi") }}</div>
      </div>

      <div class="id-row">
        <p>id:{{ info.id }}</p>
        <p>{{ $t("zise.jihuochakan") }}</p>
      </div>

      <div class="score_">
        <div class="score">
          <div>{{ $t("zise.meitidengji") }}</div>
          <div class="da_fen">{{ scoreText }}</div>
          <div>{{ $t("zise.yannzhi") }}</div>
        </div>
        <div class="phone_id">
          <div>
            {{ $t("zise.xiangxidizhi") }}：{{
              info.detail_address || $t("zise.jihuohouxianshi")
            }}
          </div>
          <div>
            {{ $t("zise.lianxiren") }}：{{
              info.lianxiren || $t("zise.jihuohouxianshi")
            }}
          </div>
        </div>
      </div>

      <div class="information">
        <div class="info">
          <div class="age">
            <van-icon name="notes-o" class="row-icon" />
            <span>
              {{ $t("setting.base_setting") }}
              {{ info.birthday || "" }}{{ $t("zise.sui") }},
              {{ $t("xuanfei.height") }}
              {{ info.height || info.hight || "" }}
            </span>
          </div>
          <div class="age">
            <van-icon name="location-o" class="row-icon" />
            <span>{{ $t("xuanfei.address") }} {{ info.address || "" }}</span>
          </div>
          <div class="age">
            <van-icon name="clock-o" class="row-icon" />
            <span>
              {{ $t("zise.fuwuxiangqing") }}
              {{ info.service || $t("zise.jihuoxianshi") }}
            </span>
          </div>
        </div>
        <div class="text_bo">
          {{ info.jianjie || $t("zise.fuwuneirong") }}
        </div>
      </div>
    </div>

    <div class="gallery">
      <img
        v-for="(src, index) in images"
        :key="index"
        :src="src"
        :alt="info.xuanfei_name"
        @click="openImg(index)"
      />
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      info: null,
      notice: "",
      defaultNotice: "",
    };
  },
  computed: {
    images() {
      if (!this.info) return [];
      const imgs = this.info.img_url;
      if (Array.isArray(imgs)) return imgs.filter(Boolean);
      if (typeof imgs === "string" && imgs) return [imgs];
      if (this.info.img) return [this.info.img];
      return [];
    },
    scoreText() {
      if (!this.info) return "88";
      const n = this.info.number;
      if (n === 0 || n === "0") return "0";
      return n != null && n !== "" ? n : "88";
    },
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    openImg(index) {
      if (!this.images.length) return;
      ImagePreview({
        images: this.images,
        startPosition: index || 0,
      });
    },
    getxuanfeidata() {
      this.$http({
        method: "get",
        url: "xuanfeidata",
        data: { id: this.$route.query.id },
      }).then((res) => {
        this.info = (res && res.data) || null;
      });
    },
    getBasicConfig() {
      this.$http({
        method: "get",
        url: "sys_config",
      }).then((res) => {
        const n = res && res.data && res.data.notice;
        if (n && n !== "Cangcode") {
          this.notice = n;
          return;
        }
        // 回退：拉公告列表第一条
        this.$http({
          method: "get",
          url: "sys_get_notice_list",
        }).then((r) => {
          const list = (r && r.data) || [];
          const first = Array.isArray(list) ? list[0] : null;
          if (first && (first.text || first.name)) {
            this.notice = first.text || first.name;
          }
        });
      });
    },
  },
  created() {
    this.getxuanfeidata();
    this.getBasicConfig();
  },
  watch: {
    "$route.query.id"() {
      this.getxuanfeidata();
    },
  },
};
</script>

<style lang="less" scoped>
.nHome-detail {
  background: #000000;
  min-height: 100vh;
  overflow: auto;
  color: #000;
}

.radiusArrow {
  position: fixed;
  left: 5.333vw;
  top: 10.667vw;
  width: 8vw;
  height: 8vw;
  background: rgba(100, 99, 105, 0.75);
  border-radius: 50%;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rt_pos {
  width: 2.4vw;
  height: 2.4vw;
  border-width: 0 0 0.667vw 0.667vw;
  border-color: #fff;
  border-style: solid;
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  margin-left: 0.8vw;
}

.hero {
  width: 100%;
  background: #111;

  img {
    width: 100%;
    display: block;
    object-fit: cover;
    max-height: 100vw;
  }
}

.content {
  background: #c9a84c;
  padding: 0 2.667vw 4vw;
  position: relative;
  top: -12.133vw;
  z-index: 9;
  overflow: hidden;
  color: #fff;
}

.notice {
  color: #ddb285;
  border: 1px solid #fff;
  border-radius: 1.333vw;
  padding-left: 0.533vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5.333vw;
  overflow: hidden;
}

::v-deep .van-notice-bar {
  flex: 1;
  height: 9vw;
  padding: 0 2vw;
  background: transparent !important;
}

::v-deep .van-notice-bar__left-icon {
  font-size: 5vw;
  color: #fff;
}

::v-deep .van-notice-bar__content {
  font-size: 3.733vw;
  color: #ddb285;
}

.icon2 {
  flex-shrink: 0;
  min-width: 16vw;
  padding: 1.6vw 2.4vw;
  margin: 1vw;
  border-radius: 1vw;
  background: linear-gradient(90deg, #f0c27f, #e8a45a);
  color: #fff;
  font-size: 3.2vw;
  text-align: center;
  font-weight: 600;
}

.id-row {
  margin-top: 3vw;
  font-size: 3.733vw;
  line-height: 1.6;

  p {
    margin: 0;
  }
}

.score_ {
  font-size: 3.2vw;
  border-radius: 1.333vw;
  border: 1px solid #fff;
  display: flex;
  align-items: center;
  padding: 2vw;
  margin-top: 4vw;
}

.score {
  width: 34%;
  text-align: center;
  padding-right: 2vw;
}

.da_fen {
  font-size: 8vw;
  font-weight: 700;
  color: #f1c79f;
  line-height: 1.1;
  margin: 1vw 0;
}

.phone_id {
  flex: 1;
  font-size: 3.2vw;
  line-height: 1.7;
  padding-left: 2vw;
  border-left: 1px solid rgba(255, 255, 255, 0.35);
}

.information {
  border-radius: 1.333vw;
  border: 1px solid #fff;
  padding: 2.667vw;
  margin-top: 2.667vw;
  margin-bottom: 2.533vw;
  font-size: 3.733vw;
}

.info {
  border-bottom: 0.267vw solid #fff;
  padding-bottom: 1.333vw;
}

.age {
  display: flex;
  align-items: center;
  line-height: 8vw;
  gap: 2vw;
}

.row-icon {
  font-size: 5vw;
  color: #f1c79f;
}

.text_bo {
  margin-top: 2.4vw;
  line-height: 1.55;
  font-size: 3.467vw;
}

.gallery {
  position: relative;
  top: -8vw;
  padding: 0 0 8vw;
  background: #000000;

  img {
    width: 100%;
    display: block;
    margin-bottom: 2vw;
    background: #141414;
  }
}
</style>
